import { ImageSource } from '../../types'
import { layout } from '../../tokens'

// Twice the page width, for high-density screens. Cloudinary's c_limit never
// enlarges an image that's smaller than this.
const DELIVERY_WIDTH = layout.pageMaxWidth * 2

let warnedNoCloud = false

/**
 * The URL to display an image from. Cloudinary uploads are resized and served
 * in the browser's best format; other URLs are used as they are.
 */
export const imageUri = (
  source: ImageSource,
  cloudinaryCloudName: string | null
): string | null => {
  if ('url' in source) return source.url
  if (!cloudinaryCloudName) {
    // Only in a misconfigured environment; say so once, rather than leaving
    // an unexplained gap where the image should be
    if (!warnedNoCloud) {
      warnedNoCloud = true
      console.warn(
        'Doclets: CLOUDINARY_NAME is not set, so uploaded images cannot be shown.'
      )
    }
    return null
  }
  return `https://res.cloudinary.com/${cloudinaryCloudName}/image/upload/c_limit,w_${DELIVERY_WIDTH},f_auto,q_auto/${source.publicId}`
}
